import { useEffect, useCallback } from 'react';

/**
 * Custom hook to handle ESC key press
 * @param {Function} callback - Function to call when ESC is pressed
 * @param {boolean} isActive - Whether the hook should be active (default: true)
 */
export const useEscapeKey = (callback, isActive = true) => {
  const handleEscapeKey = useCallback(
    (event) => {
      if (event.key === 'Escape' && isActive) {
        event.preventDefault();
        event.stopPropagation();
        callback();
      }
    },
    [callback, isActive]
  );

  useEffect(() => {
    if (isActive) {
      document.addEventListener('keydown', handleEscapeKey, true);
      return () => {
        document.removeEventListener('keydown', handleEscapeKey, true);
      };
    }
  }, [handleEscapeKey, isActive]);
};

export default useEscapeKey;
